// D6-4 — **EVERY MEMBER NAME ANYWHERE IS A DOOR.**
//
// Her sentence: "tap it and the member modal opens right there, without leaving the tab." So a
// member's name is never plain text on this dashboard — it is this, one component, used by every
// tab that names a member. One component rather than a button per tab is what makes the fixture
// possible: `scripts/d6-command-center.mjs` renders each tab and asserts the door is there.
//
// THE ONE CASE THAT IS NOT A DOOR, and it is deliberate: a message from someone who was never
// signed in has no member behind it (`userId` null). That renders as the plain name it is. A door
// that opens onto nothing is worse than no door — she taps it, a modal fails to load, and she
// learns not to trust the ones that do work.
//
// Props in, tree out, no hook and no fetch.
export function MemberDoor({
  id, name, email, onOpen, className = "",
}: {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  onOpen: (id: string) => void;
  className?: string;
}) {
  const shown = String(name || "").trim() || String(email || "").trim() || (id ? `#${id}` : "Someone");
  if (!id) return <span className={`owner-door is-plain ${className}`.trim()}>{shown}</span>;
  return (
    <button
      type="button"
      className={`owner-door ${className}`.trim()}
      onClick={() => onOpen(String(id))}
      aria-label={`Open ${shown}`}
    >
      {shown}
    </button>
  );
}
